module.exports = ".ecg-btn.cm {\n  line-height: 40px;\n  height: 40px;\n  font-weight: bold; }\n"